import React from 'react';
import {
    CModal,
    CModalBody,
} from '@coreui/react';
import PropTypes from 'prop-types';

const UpdatePaymentPopup = ({ show, onClose, children }) => {
    return (
        <div className="popup-update-payment">
            <CModal
                visible={show}
                onClose={onClose}
                alignment="center"
                portal={false}
            >
                <CModalBody>
                    {children}
                </CModalBody>
            </CModal>
        </div>
    )
}
 
UpdatePaymentPopup.propTypes = {
    visible: PropTypes.bool,
    onClose: PropTypes.func,
     children: PropTypes.node,
     show: PropTypes.any,
}

export default UpdatePaymentPopup
